/* DON'T EDIT THIS FILE: edit original and run build again */ import deepEqual from "fast-deep-equal";
import { useMemoCompare } from "./use-memo-compare.ts";

export const useDeepMemo = <T>(next: T): T => {
  return useMemoCompare(next, deepEqual);
};
